"use client";

import "@/configs/amplify";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
